// import React, { useEffect, useRef, useState } from "react";
// import {
//   FaUser,
//   FaPhone,
//   FaHome,
//   FaCalendarAlt,
//   FaMoneyBillWave,
//   FaFileAlt,
//   FaBriefcase,
//   FaPlusCircle,
//   FaCommentDots,
//   FaSpinner,
//   FaUserCog,
// } from "react-icons/fa"; // Import icons
// import Dropdown from "../Common/Dropdown/main";
// import { Popup } from "../Common/Popup/main";
// import SuggestionInput from "../Common/SuggestionInput/main";
// import { useProperties } from "../../hook/useProperties";
// import { UnoccupiedProperty } from "../../hook/useProperties";
// //import { Property } from "../../hook/types/property";

// interface Tenant {
//   id?: number;
//   name: string;
//   contact: string;
//   email: string | null;
//   propertyAddress: string;
//   dueDate: number;
//   occupiedDate: string;
//   vacatedDate: string;
//   propertyName?:string;
//   // rentStatus: string;
//   depositAmount: number;
//   //propertyDepositAmount: number;
//   rent: number;
//   occupation: string;
//   document: string | null;
//   comments: string;
//   tenantImage: string | null;
//   openingBalance: number;
//   isActive : boolean;
// }
// interface Property {
//   id: number;
//   isActive: boolean;
//   noOfRooms: number;
//   propertyAddress: string;
//   propertyDepositAmount: number;
//   propertyImageUrl: string | null;
//   propertyName: string;
//   propertyRent: number;
//   propertySize: number;
//   propertyStatus: string;
//   propertyType: string;
//   tenantContact: string | null;
//   tenantName: string | null;
// }

// interface PropertyData {
//   UNOCCUPIED: Property[];
// } 

// interface TenantFormProps {
//   initialData: Tenant;
//   onSubmit: (formData: Tenant) => void;
//   onCancel?: () => void;
//   isOpen: boolean;
//   isLoading:boolean;
//   id?: string;
// }


// const TenantForm: React.FC<TenantFormProps> = ({
//   initialData,
//   onSubmit,
//   onCancel,
//   isOpen,
//   isLoading,
//   id,
// }) => {
 
//   const [formData, setFormData] = useState<Omit<Tenant, "id">>({
//     name: initialData?.name || "",
//     contact: initialData?.contact || "",
//     email: initialData?.email || "",
//     propertyAddress: initialData?.propertyAddress || "",
//     dueDate: initialData?.dueDate || 0,
//     occupiedDate: initialData?.occupiedDate || "",
//      vacatedDate: initialData?.vacatedDate || "",
//     // rentStatus: initialData?.rentStatus || "",
//     propertyName:initialData?.propertyName||"",
//     depositAmount: initialData?.depositAmount || 0,
//     rent: initialData?.rent || 0,
//     occupation: initialData?.occupation || "",
    
//     document:
//       initialData?.document || (initialData as any)?.documentUrl || null,
//     comments: initialData?.comments || "",
//     tenantImage:
//       initialData?.tenantImage || (initialData as any)?.tenantImageUrl || null,
//     openingBalance: initialData?.openingBalance || 0,
//  isActive: initialData?.isActive ?? true,
 
//   });
//   //const { Property } = useProperties();
//   //const PropertyData = Property({ active: true });

//  // const { Property } = useProperties();
//   // const PropertyData = UnoccupiedProperty({ active: true });
//   // console.log("PropertyData:", PropertyData);
// //  const { data: PropertyData, isLoading: isPropertyLoading, error } = UnoccupiedProperty({ active: true });
// // useEffect(() => {
// // //console.log("PropertyData:", PropertyData );
// // }, [PropertyData]);

// // const { data: PropertyData, isLoading: isPropertyLoading, error } = UnoccupiedProperty({ active: true });
// // // useEffect(() => {
// // //   console.log("Full API Response:", PropertyData);
// // // }, [PropertyData]);


// const { data: unoccupiedProperties, isLoading: isPropertyLoading, error } = UnoccupiedProperty({ active: true });

// useEffect(() => {
// // console.log("Unoccupied Properties (Component):", unoccupiedProperties);
// }, [unoccupiedProperties]);



//   const [errors, setErrors] = useState<{ [key: string]: string }>({});

//   const [url1, setUrl1] = useState("");

//   const [url2, setUrl2] = useState("");

//   const [showPopup, setShowPopup] = useState(false); // State to control popup visibility

//   const [imageUrl, setImageUrl] = useState<string | null>(null); // State to hold the image URL
// //const [dueDateDropdownOpen, setDueDateDropdownOpen] = useState(false);
// // New state for the active/inactive toggle
//     const [activeStatus, setActiveStatus] = useState<boolean>(initialData?.isActive ?? true);

  
// const useOutsideClick = (callback: () => void) => {
//   const ref = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (ref.current && !ref.current.contains(event.target as Node)) {
//         callback();
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [callback]);

//   return ref;
// };
// const [dueDateDropdownOpen, setDueDateDropdownOpen] = useState(false);
// const dueDateRef = useOutsideClick(() => setDueDateDropdownOpen(false));
//   useEffect(() => {
//        // Format vacatedDate here before setting the form data
//     const formattedVacatedDate = initialData?.vacatedDate
//       ? initialData.vacatedDate.split("T")[0]
//       : ""; // This extracts "YYYY-MM-DD"
//     setFormData({
//       name: initialData?.name || "",
//       contact: initialData?.contact || "",
//       email: initialData?.email || null,
//       propertyAddress: initialData?.propertyAddress || "",
//       propertyName:initialData?.propertyName||"",
//       dueDate: initialData?.dueDate || 0,
//       occupiedDate: initialData?.occupiedDate || "",
//       vacatedDate: formattedVacatedDate,
//       // rentStatus: initialData?.rentStatus || "",
//       depositAmount: initialData?.depositAmount || 0,

//       rent: initialData?.rent || 0,
//       occupation: initialData?.occupation || "",
//       document:
//         initialData?.document || (initialData as any)?.documentUrl || null,
//       comments: initialData?.comments || "",
//       tenantImage:
//         initialData?.tenantImage ||
//         (initialData as any)?.tenantImageUrl ||
//         null,
//       openingBalance: initialData?.openingBalance || 0,
//      isActive: activeStatus,
//     });
//     setActiveStatus(activeStatus); 
//     // setActiveStatus(initialData?.isActive ?? true); 
//   }, [initialData]);
 
//   const handleChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//   ) => {
//     setFormData({
//       ...formData,
//       [e.target.id]: e.target.value,
//     });
//   };

//    // New handler for the toggle switch
//     const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const newStatus = e.target.checked;
//         setActiveStatus(newStatus);
//         setFormData((prev) => ({ ...prev, isActive: newStatus }));
//     };

// // console.log(formData);
//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = Array.from(e.target.files || []);
//     // const files =(e.target.files?.[0]);
//     const newDocumentUrl1 =
//       files.length > 0 ? URL.createObjectURL(files[0]) : null;
//     setUrl1(newDocumentUrl1 as any);
//     setFormData({
//       ...formData,
//       document: files[0] as any,
//     });
//   };

//   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = Array.from(e.target.files || []);
//     //  const files =(e.target.files?.[0]);
//     const newDocumentUrl2 =
//       files.length > 0 ? URL.createObjectURL(files[0]) : null;
//     setUrl2(newDocumentUrl2 as any);
//     setFormData({
//       ...formData,
//       tenantImage: files[0] as any,
//     });
//   };

//   const validate = (): boolean => {
//     const newErrors: { [key: string]: string } = {};
//     const fields = [
//       "name",
//       "contact",
//       // "email",
//       "propertyAddress",

//       // "occupation",
//       "dueDate",
//       "occupiedDate",
//       "depositAmount",
//       "rent",
//       // "rentStatus",
//       // "openingBalance",
//     ];

//     fields.forEach((field) => {
//       if (!formData[field as keyof typeof formData]) {
//         newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
//       }
//     });

//     if (isNaN(Number(formData.contact))) {
//       newErrors.contact = "Contact must be a valid number.";
//     }

//     if (isNaN(Number(formData.depositAmount))) {
//       newErrors.depositAmount = "Deposit amount must be a valid number.";
//     }

//     if (isNaN(Number(formData.rent))) {
//       newErrors.rent = "Rent must be a valid number.";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // const handleSubmit = (e: React.FormEvent) => {
//   //   e.preventDefault();
//   //   if (validate()) {
//   //     onSubmit({
//   //       name: formData.name,
//   //       contact: formData.contact,
//   //       email: formData.email,
//   //       propertyAddress: formData.propertyAddress,
//   //       dueDate: formData.dueDate,
//   //       occupiedDate: formData.occupiedDate,
//   //       depositAmount: formData.depositAmount,
//   //       rent: formData.rent,
//   //       occupation: formData.occupation,
//   //       document: formData.document,
//   //       comments: formData.comments,
//   //       tenantImage: formData.tenantImage,
//   //       openingBalance: formData.openingBalance
//   //     });
//   //   }
//   // };
//   const [loading, setLoading] = useState(false);
//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
    
//     if (validate()) {
//       setLoading(true);
      
//       try {
//         await onSubmit({
//           name: formData.name,
//           contact: formData.contact,
//           email: formData.email,
//           propertyAddress: formData.propertyAddress,
//           dueDate: formData.dueDate,
//           occupiedDate: formData.occupiedDate,
//           vacatedDate: formData.vacatedDate,
//           depositAmount: formData.depositAmount,
//           rent: formData.rent,
//           occupation: formData.occupation,
//           document: formData.document,
//           comments: formData.comments,
//           tenantImage: formData.tenantImage,
//           openingBalance: formData.openingBalance,
//           isActive: formData.isActive ?? true
//         });
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const handleImageClick = (url: string | null) => {
//     setImageUrl(url);
//     setShowPopup(true);
//   };

//   const closePopup = () => {
//     setShowPopup(false);
//     setImageUrl(null);
//   };

//   if (!isOpen) {
//     return null;
//   }

// const DueDateOptions = Array.from({ length: 31 }, (_, i) => (i + 1).toString());

// // --- Toggle Switch Component ---
//     const ToggleSwitch: React.FC = () => (
//         <div className="flex items-center space-x-2">
//             <label htmlFor="active-toggle" className="block text-sm text-gray-700 font-bold flex items-center">
//                 <FaUserCog className="mr-2 h-5 text-green-500 w-5" /> Status:
//             </label>
//             <label className="relative inline-flex items-center cursor-pointer">
//                 <input
//                     type="checkbox"
//                     id="active-toggle"
//                     className="sr-only peer"
//                     checked={activeStatus}
//                     onChange={handleToggleChange}
//                     disabled={isLoading}
//                 />
//                 <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary"></div>
//                 <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
//                     {activeStatus ? 'Active' : 'Inactive'}
//                 </span>
//             </label>
//         </div>
//     );
//     // --- End Toggle Switch Component ---

//   return (
//     <div className="bg-white rounded-lg  w-full max-w-3xl mx-auto p-2 sm:p-3 lg:p-5">
//       <h1 className="text-lg font-bold mb-4 flex justify-between items-center">
//         Tenant Information{" "}
//         <span className="text-md italic pr-10">{id ? id : ""}</span>
//       </h1>
//       <form className="space-y-4" onSubmit={handleSubmit}>
//         <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
//           <div>
//             <label
//               htmlFor="name"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaUser className="mr-2 text-blue-500 h-4 w-4" /> Name
//             </label>
//             <input
//               type="text"
//               id="name"
//               value={formData.name}
//               onChange={handleChange}
//               className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
//             />
//             {errors.name && (
//               <p className="text-red-500 text-xs italic">{errors.name}</p>
//             )}
//           </div>
//           <div>
//             <label
//               htmlFor="contact"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaPhone className="mr-2 text-green-500 h-4 w-4" /> Phone Number
//             </label>
//             <input
//               type="text"
//               id="contact"
//               value={formData.contact}
//               onChange={handleChange}
//                maxLength={10} 
//               className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
//             />
//             {errors.contact && (
//               <p className="text-red-500 text-xs italic">{errors.contact}</p>
//             )}
//           </div>
//           <div>
//             <label
//               htmlFor="email"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaUser className="mr-2 text-blue-500 h-4 w-4" /> Email
//             </label>
//             <input
//               type="email"
//               id="email"
//               value={formData.email  || ""}
//               onChange={handleChange}
//               className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
//             />
//             {errors.email && (
//               <p className="text-red-500 text-xs italic">{errors.email}</p>
//             )}
//           </div>
//           <div>
//             <label
//               htmlFor="propertyAddress"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaHome className="mr-2 text-yellow-500 h-4 w-4" /> Property Name
//             </label>
           

// {isPropertyLoading ? (
//   <SuggestionInput
//     loading={true} // Show loading state inside the input
//     suggestions={[]} // No suggestions while loading
//     activeValue={formData.propertyName}
//     setActiveValue={(value: string) => {
//       setFormData({ ...formData, propertyName: value });
//     }}
//     setActiveIndex={() => {}} // No action while loading
//   />
// ) : (
//   <SuggestionInput
//     key={unoccupiedProperties.length}
//     suggestions={unoccupiedProperties.map((property: { propertyName: any; }) => property.propertyName)}
//     setActiveValue={(value: string) => {
//       setFormData({ ...formData, propertyName: value });
//     }}
//     activeValue={formData.propertyName}
//     setActiveIndex={(index: number) => {
//       const selectedProperty = unoccupiedProperties[index];
//       if (selectedProperty) {
//         setFormData({
//           ...formData,
//           depositAmount: selectedProperty.propertyDepositAmount,
//           rent: selectedProperty.propertyRent,
//           propertyAddress: selectedProperty.id,
//           propertyName: selectedProperty.propertyName,
//         });
//       }
//     }}
//     loading={false} // No loading state
//   />
// )}
//             {errors.propertyAddress && (
//               <p className="text-red-500 text-xs italic">
//                 {errors.propertyAddress}
//               </p>
              
//             )}
//           </div>
//           <div>
//             <label
//               htmlFor="occupation"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaBriefcase className="mr-2 text-purple-500 h-4 w-4" />{" "}
//               Occupation
//             </label>
//             <input
//               type="text"
//               id="occupation"
//               value={formData.occupation}
//               onChange={handleChange}
//               className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
//             />
//             {errors.occupation && (
//               <p className="text-red-500 text-xs italic">{errors.occupation}</p>
//             )}
//           </div>
//           <div>
//             <label
//               htmlFor="dueDate"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaCalendarAlt className="mr-2 text-orange- 500 h-4 w-4" /> Due
//               Date
//             </label>


      
//            <div 
//            ref={dueDateRef}
//            onClick={() => setDueDateDropdownOpen(!dueDateDropdownOpen)}>
//               <Dropdown
//                 options={DueDateOptions}
//                 onSelect={(e: any) => {
//                   setFormData({ ...formData, dueDate: parseInt(e) });
//                   setDueDateDropdownOpen(false);
//                 }}
//                 activeOption={JSON.stringify(formData.dueDate)}
//                 className2="py-2"
//                 className="w-[100%]"
//                 isOpen={dueDateDropdownOpen}
//                 setIsOpen={setDueDateDropdownOpen}
//                 closeOtherDropdown={() => {}}
//               />
//             </div>
           
//             {errors.dueDate && (
//               <p className="text-red-500 text-xs italic">{errors.dueDate}</p>
//             )}
//           </div>
//           <div>
//             <label
//               htmlFor="occupiedDate"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaCalendarAlt className="mr-2 text-orange-500 h-4 w-4" />{" "}
//               Occupied Date
//             </label>
//             <input
//               type="date"
//               id="occupiedDate"
//               value={formData.occupiedDate}
//               onChange={handleChange}
//               className="shadow appearance-none border rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//             />
//             {errors.occupiedDate && (
//               <p className="text-red-500 text-xs italic">
//                 {errors.occupiedDate}
//               </p>
//             )}
//           </div>
//               <div>
//             <label
//               htmlFor="vacatedDate"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaCalendarAlt className="mr-2 text-orange-500 h-4 w-4" />{" "}
//               Vacated Date
//             </label>
//             <input
//               type="date"
//               id="vacatedDate"
//               value={formData.vacatedDate}
//               onChange={handleChange}
//               className="shadow appearance-none border rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//             />
//             {errors.vacatedDate && (
//               <p className="text-red-500 text-xs italic">
//                 {errors.vacatedDate}
//               </p>
//             )}
//           </div>
//           <div>
//             <label
//               htmlFor="depositAmount"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaMoneyBillWave className="mr-2 text-green-500 h-4 w-4" />{" "}
//               Deposit Amount
//             </label>
//             <input
//               type="number"
//               disabled
//               id="depositAmount"
//               value={formData.depositAmount}
//               onChange={handleChange}
//               className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
//             />
//             {errors.depositAmount && (
//               <p className="text-red-500 text-xs italic">
//                 {errors.depositAmount}
//               </p>
//             )}
//           </div>
//           <div>
//             <label
//               htmlFor="rent"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaMoneyBillWave className="mr-2 text-green-500 h-4 w-4" /> Rent
//             </label>
//             <input
//               type="number"
//               id="rent"
//               disabled
//               value={formData.rent}
//               onChange={handleChange}
//               className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
//             />
//             {errors.rent && (
//               <p className="text-red-500 text-xs italic">{errors.rent}</p>
//             )}
//           </div>
       

//           <div>
//             <label
//               htmlFor="openingBalance"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaMoneyBillWave className="mr-2 text-green-500 h-4 w-4" />{" "}
//               Opening Balance
//             </label>
//             <input
//               type="number"
//               id="openingBalance"
//               value={formData.openingBalance}
//               onChange={handleChange}
//               className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
//             />
//             {errors.openingBalance && (
//               <p className="text-red-500 text-xs italic">
//                 {errors.openingBalance}
//               </p>
//             )}
//           </div>

//           <div className="flex items-end"> {/* Changed to items-end to align with input */}
//     <div className="w-full mt-[22px]"> {/* Adjusted margin to match label height */}
//       <div className="flex items-center space-x-2">
//         <label htmlFor="active-toggle" className="block text-sm text-gray-700 font-bold flex items-center">
//           <FaUserCog className="mr-2 h-5 text-green-500 w-5" /> Status:
//         </label>
//         <label className="relative inline-flex items-center cursor-pointer">
//           <input
//             type="checkbox"
//             id="active-toggle"
//             className="sr-only peer"
//             checked={activeStatus}
//             onChange={handleToggleChange}
//             disabled={isLoading}
//           />
//           <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
//           <span className="ms-3 text-sm font-medium text-gray-900">
//             {activeStatus ? 'Active' : 'Inactive'}
//           </span>
//         </label>
//       </div>
//     </div>
//   </div>
//           <div className="mt-4">
//             <label
//               htmlFor="tenatsImageUrl"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaUser className="mr-2 text-blue-500 h-4 w-4" /> Tenant Image
//             </label>
//             <input
//               type="file"
//               id="tenatsImageUrl"
//               onChange={handleImageChange}
//               className="hidden"
//             />
//             <label
//               htmlFor="tenatsImageUrl"
//               className="cursor-pointer text-blue-500"
//             >
//               Drag and drop file here or click to upload
//             </label>
//             {formData.tenantImage && (
//               <p className="text-sm text-gray-700">
//                 Image uploaded:{" "}
//                 <span
//                   className="cursor-pointer"
//                   onClick={() =>
//                     handleImageClick(url2 ? url2 : formData.tenantImage)
//                   }
//                   rel="noopener noreferrer"
//                 >
//                   View
//                 </span>
//               </p>
//             )}
//           </div>
//           <div className="mt-4">
//             <label
//               htmlFor="documentUrl"
//               className="text-sm text-gray-700 font-bold flex items-center"
//             >
//               <FaPlusCircle className="mr-2 text-red-500 h-4 w-4" /> Upload
//               Document
//             </label>
//             <input
//               type="file"
//               id="documentUrl"
//               onChange={handleFileChange}
//               className="hidden"
//             />
//             <label
//               htmlFor="documentUrl"
//               className="cursor-pointer text-blue-500"
//             >
//               Drag and drop file here or click to upload
//             </label>
//             {formData.document && (
//               <p className="text-sm text-gray-700">
//                 Document uploaded:{" "}
//                 <span
//                   onClick={() =>
//                     handleImageClick(url1 ? url1 : formData.document)
//                   }
//                   className="cursor-pointer"
//                   rel="noopener noreferrer"
//                 >
//                   View
//                 </span>
//               </p>
//             )}
//           </div>
//         </div>

//         <div className="mt-4">
//           <label
//             htmlFor="comments"
//             className="text-sm text-gray-700 font-bold flex items-center"
//           >
//             <FaCommentDots className="text-indigo-500 h-5 w-5 mr-2" /> Comments
//           </label>
//           <textarea
//             id="comments"
//             value={formData.comments}
//             onChange={handleChange}
//             className=" shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
//           />
//         </div>
 
//         <div className="flex flex-col sm:flex-row justify-end mt-4 space-y-2 sm:space-y-0 sm:space-x-4">
//           <button
//             disabled={isLoading}
//             type="submit"
//             className="bg-primary hover:bg-secondary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
//           >
//              {isLoading?<p className="flex justify-center items-center"><FaSpinner className="animate-spin mr-2"/> Updating...</p>:"Save"}
//           </button>
//           <button
//             type="button"
//             onClick={onCancel}
//             className="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
//           >
//             Cancel
//           </button>
//         </div>
//       </form>
//       {/* Popup for uploaded images */}
//       {showPopup && (
//         <Popup closeButton={true} onClose={closePopup}>
//           <img
//             src={imageUrl || ""}
//             alt="Uploaded"
//             className="max-w-full max-h-full"
//           />
//         </Popup>
//       )}
//     </div>
//   );
// };
// export default TenantForm;





import React, { useEffect, useRef, useState } from "react";
import {
  FaUser,
  FaPhone,
  FaHome,
  FaCalendarAlt,
  FaMoneyBillWave,
  FaFileAlt,
  FaBriefcase,
  FaPlusCircle,
  FaCommentDots,
  FaSpinner,
  FaUserCog,
} from "react-icons/fa"; // Import icons
import Dropdown from "../Common/Dropdown/main";
import { Popup } from "../Common/Popup/main";
import SuggestionInput from "../Common/SuggestionInput/main";
import { useProperties } from "../../hook/useProperties";
import { UnoccupiedProperty } from "../../hook/useProperties";
import toast from "react-hot-toast";
import { MdClose } from "react-icons/md";
//import { Property } from "../../hook/types/property";

interface Tenant {
  id?: number;
  name: string;
  contact: string;
  email: string | null;
  propertyAddress: string;
  dueDate: number;
  occupiedDate: string;
  vacatedDate: string;
  propertyName?:string;
  // rentStatus: string;
  depositAmount: number;
  //propertyDepositAmount: number;
  rent: number;
  occupation: string;
  document: string | null;
  comments: string;
  tenantImage: string | null;
  openingBalance: number;
  isActive : boolean;
}
interface Property {
  id: number;
  isActive: boolean;
  noOfRooms: number;
  propertyAddress: string;
  propertyDepositAmount: number;
  propertyImageUrl: string | null;
  propertyName: string;
  propertyRent: number;
  propertySize: number;
  propertyStatus: string;
  propertyType: string;
  tenantContact: string | null;
  tenantName: string | null;
}

interface PropertyData {
  UNOCCUPIED: Property[];
} 

interface TenantFormProps {
  initialData: Tenant;
  onSubmit: (formData: Tenant) => void;
  onCancel?: () => void;
  isOpen: boolean;
  isLoading:boolean;
  id?: string;
}


// Document Viewer Component (same as in your TenantPopup)
const DocumentViewer: React.FC<{
  isOpen: boolean;
  url: string;
  type: string;
  tenantId: number;
  onClose: () => void;
}> = ({ isOpen, url, type, tenantId, onClose }) => {
  const [documentUrl, setDocumentUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchDocument = async (): Promise<string | null> => {
    try {
      const token = localStorage.getItem('R_M_t');
     const apiUrl = `https://api.selvamrentalmanagement.space/api/v1/tenants/${tenantId}/document`;
      //   const apiUrl = `http://localhost:8080/api/v1/tenants/${tenantId}/document`;
      
      const response = await fetch(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch document: ${response.status} ${response.statusText}`);
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      return url;
    } catch (err) {
      console.error('Error in fetchDocument:', err);
      toast.error('Failed to load document');
      return null;
    }
  };

  useEffect(() => {
    if (isOpen) {
      const loadDocument = async () => {
        setLoading(true);
        setDocumentUrl(null);
        
        try {
          const fetchedUrl = await fetchDocument();
          setDocumentUrl(fetchedUrl);
        } catch (error) {
          console.error('Error loading document:', error);
          toast.error('Failed to load document');
        } finally {
          setLoading(false);
        }
      };
      
      loadDocument();
    }

    return () => {
      if (documentUrl && documentUrl.startsWith('blob:')) {
        URL.revokeObjectURL(documentUrl);
      }
    };
  }, [isOpen, tenantId]);

  if (!isOpen) return null;

  const isPdf = type === 'pdf' || url.toLowerCase().endsWith('.pdf');
  const isImage = type === 'image' || 
    ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].some(ext => 
      url.toLowerCase().endsWith(`.${ext}`)
    );

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-medium">Document Viewer</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ✕
          </button>
        </div>
        <div className="p-4">
          {loading ? (
            <div className="flex items-center justify-center h-[70vh]">
              <FaSpinner className="animate-spin mr-2 text-2xl" />
              <p>Loading document...</p>
            </div>
          ) : isImage && documentUrl ? (
            <img 
              src={documentUrl} 
              alt="Document" 
              className="max-w-full max-h-[70vh] mx-auto"
              onError={() => {
                toast.error('Failed to load image');
              }}
            />
          ) : isPdf && documentUrl ? (
            <embed
              src={`${documentUrl}#view=FitH`}
              type="application/pdf"
              className="w-full h-[70vh]"
            />
          ) : documentUrl ? (
            <iframe 
              src={documentUrl} 
              className="w-full h-[70vh] border-0"
              title="Document Viewer"
              onError={() => {
                toast.error('Failed to load document');
              }}
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-[70vh]">
              <FaFileAlt className="w-16 h-16 text-gray-400 mb-4" />
              <p className="text-gray-500">Could not load document</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const TenantForm: React.FC<TenantFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
  isOpen,
  isLoading,
  id,
}) => {
 
  const [formData, setFormData] = useState<Omit<Tenant, "id">>({
    name: initialData?.name || "",
    contact: initialData?.contact || "",
    email: initialData?.email || "",
    propertyAddress: initialData?.propertyAddress || "",
    dueDate: initialData?.dueDate || 0,
    occupiedDate: initialData?.occupiedDate || "",
     vacatedDate: initialData?.vacatedDate || "",
    // rentStatus: initialData?.rentStatus || "",
    propertyName:initialData?.propertyName||"",
    depositAmount: initialData?.depositAmount || 0,
    rent: initialData?.rent || 0,
    occupation: initialData?.occupation || "",
    
    document:
      initialData?.document || (initialData as any)?.documentUrl || null,
    comments: initialData?.comments || "",
    tenantImage:
      initialData?.tenantImage || (initialData as any)?.tenantImageUrl || null,
    openingBalance: initialData?.openingBalance || 0,
 isActive: initialData?.isActive ?? true,
 
  });
  //const { Property } = useProperties();
  //const PropertyData = Property({ active: true });

 // const { Property } = useProperties();
  // const PropertyData = UnoccupiedProperty({ active: true });
  // console.log("PropertyData:", PropertyData);
//  const { data: PropertyData, isLoading: isPropertyLoading, error } = UnoccupiedProperty({ active: true });
// useEffect(() => {
// //console.log("PropertyData:", PropertyData );
// }, [PropertyData]);

// const { data: PropertyData, isLoading: isPropertyLoading, error } = UnoccupiedProperty({ active: true });
// // useEffect(() => {
// //   console.log("Full API Response:", PropertyData);
// // }, [PropertyData]);


const { data: unoccupiedProperties, isLoading: isPropertyLoading, error } = UnoccupiedProperty({ active: true });

useEffect(() => {
// console.log("Unoccupied Properties (Component):", unoccupiedProperties);
}, [unoccupiedProperties]);

  const [documentViewer, setDocumentViewer] = useState({
    isOpen: false,
    url: '',
    type: '',
  });

  // Add image viewer state
  const [imageToShow, setImageToShow] = useState<string | null>(null);


    // Add document click handler
  const handleDocumentClick = async (documentUrl: string | null) => {
    if (!documentUrl) {
      toast.error("No document available to view.");
      return;
    }

    // Determine the type of document
    const extension = documentUrl.split('.').pop()?.toLowerCase() || '';
    const isPdf = extension === 'pdf';
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(extension);
    
    setDocumentViewer({
      isOpen: true,
      url: documentUrl,
      type: isImage ? 'image' : (isPdf ? 'pdf' : 'document')
    });
  };

 const handleImageClick = (imageUrl: string | null) => {
    if (imageUrl && imageUrl.startsWith("http")) {
      setImageToShow(imageUrl);
    } else {
      toast.error("No valid image available to view.");
    }
  };
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const [url1, setUrl1] = useState("");

  const [url2, setUrl2] = useState("");

  const [showPopup, setShowPopup] = useState(false); // State to control popup visibility

  const [imageUrl, setImageUrl] = useState<string | null>(null); // State to hold the image URL
//const [dueDateDropdownOpen, setDueDateDropdownOpen] = useState(false);
// New state for the active/inactive toggle
    const [activeStatus, setActiveStatus] = useState<boolean>(initialData?.isActive ?? true);

  
const useOutsideClick = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback]);

  return ref;
};
const [dueDateDropdownOpen, setDueDateDropdownOpen] = useState(false);
const dueDateRef = useOutsideClick(() => setDueDateDropdownOpen(false));
  useEffect(() => {
       // Format vacatedDate here before setting the form data
    const formattedVacatedDate = initialData?.vacatedDate
      ? initialData.vacatedDate.split("T")[0]
      : ""; // This extracts "YYYY-MM-DD"
    setFormData({
      name: initialData?.name || "",
      contact: initialData?.contact || "",
      email: initialData?.email || null,
      propertyAddress: initialData?.propertyAddress || "",
      propertyName:initialData?.propertyName||"",
      dueDate: initialData?.dueDate || 0,
      occupiedDate: initialData?.occupiedDate || "",
      vacatedDate: formattedVacatedDate,
      // rentStatus: initialData?.rentStatus || "",
      depositAmount: initialData?.depositAmount || 0,

      rent: initialData?.rent || 0,
      occupation: initialData?.occupation || "",
      document:
        initialData?.document || (initialData as any)?.documentUrl || null,
      comments: initialData?.comments || "",
      tenantImage:
        initialData?.tenantImage ||
        (initialData as any)?.tenantImageUrl ||
        null,
      openingBalance: initialData?.openingBalance || 0,
     isActive: activeStatus,
    });
    setActiveStatus(activeStatus); 
    // setActiveStatus(initialData?.isActive ?? true); 
  }, [initialData]);
 
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

   // New handler for the toggle switch
    const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newStatus = e.target.checked;
        setActiveStatus(newStatus);
        setFormData((prev) => ({ ...prev, isActive: newStatus }));
    };

// console.log(formData);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    // const files =(e.target.files?.[0]);
    const newDocumentUrl1 =
      files.length > 0 ? URL.createObjectURL(files[0]) : null;
    setUrl1(newDocumentUrl1 as any);
    setFormData({
      ...formData,
      document: files[0] as any,
    });
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    //  const files =(e.target.files?.[0]);
    const newDocumentUrl2 =
      files.length > 0 ? URL.createObjectURL(files[0]) : null;
    setUrl2(newDocumentUrl2 as any);
    setFormData({
      ...formData,
      tenantImage: files[0] as any,
    });
  };

  const validate = (): boolean => {
    const newErrors: { [key: string]: string } = {};
    const fields = [
      "name",
      "contact",
      // "email",
      "propertyAddress",

      // "occupation",
      "dueDate",
      "occupiedDate",
      "depositAmount",
      "rent",
      // "rentStatus",
      // "openingBalance",
    ];

    fields.forEach((field) => {
      if (!formData[field as keyof typeof formData]) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
      }
    });

    if (isNaN(Number(formData.contact))) {
      newErrors.contact = "Contact must be a valid number.";
    }

    if (isNaN(Number(formData.depositAmount))) {
      newErrors.depositAmount = "Deposit amount must be a valid number.";
    }

    if (isNaN(Number(formData.rent))) {
      newErrors.rent = "Rent must be a valid number.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   if (validate()) {
  //     onSubmit({
  //       name: formData.name,
  //       contact: formData.contact,
  //       email: formData.email,
  //       propertyAddress: formData.propertyAddress,
  //       dueDate: formData.dueDate,
  //       occupiedDate: formData.occupiedDate,
  //       depositAmount: formData.depositAmount,
  //       rent: formData.rent,
  //       occupation: formData.occupation,
  //       document: formData.document,
  //       comments: formData.comments,
  //       tenantImage: formData.tenantImage,
  //       openingBalance: formData.openingBalance
  //     });
  //   }
  // };
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (validate()) {
      setLoading(true);
      
      try {
        await onSubmit({
          name: formData.name,
          contact: formData.contact,
          email: formData.email,
          propertyAddress: formData.propertyAddress,
          dueDate: formData.dueDate,
          occupiedDate: formData.occupiedDate,
          vacatedDate: formData.vacatedDate,
          depositAmount: formData.depositAmount,
          rent: formData.rent,
          occupation: formData.occupation,
          document: formData.document,
          comments: formData.comments,
          tenantImage: formData.tenantImage,
          openingBalance: formData.openingBalance,
          isActive: formData.isActive ?? true
        });
      } finally {
        setLoading(false);
      }
    }
  };

  // const handleImageClick = (url: string | null) => {
  //   setImageUrl(url);
  //   setShowPopup(true);
  // };

  const closePopup = () => {
    setShowPopup(false);
    setImageUrl(null);
  };

  if (!isOpen) {
    return null;
  }

const DueDateOptions = Array.from({ length: 31 }, (_, i) => (i + 1).toString());

// --- Toggle Switch Component ---
    const ToggleSwitch: React.FC = () => (
        <div className="flex items-center space-x-2">
            <label htmlFor="active-toggle" className="block text-sm text-gray-700 font-bold flex items-center">
                <FaUserCog className="mr-2 h-5 text-green-500 w-5" /> Status:
            </label>
            <label className="relative inline-flex items-center cursor-pointer">
                <input
                    type="checkbox"
                    id="active-toggle"
                    className="sr-only peer"
                    checked={activeStatus}
                    onChange={handleToggleChange}
                    disabled={isLoading}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary"></div>
                <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                    {activeStatus ? 'Active' : 'Inactive'}
                </span>
            </label>
        </div>
    );
    // --- End Toggle Switch Component ---

  return (
    <div className="bg-white rounded-lg  w-full max-w-3xl mx-auto p-2 sm:p-3 lg:p-5">
      <h1 className="text-lg font-bold mb-4 flex justify-between items-center">
        Tenant Information{" "}
        <span className="text-md italic pr-10">{id ? id : ""}</span>
      </h1>
      <form className="space-y-4" onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
          <div>
            <label
              htmlFor="name"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaUser className="mr-2 text-blue-500 h-4 w-4" /> Name
            </label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
            />
            {errors.name && (
              <p className="text-red-500 text-xs italic">{errors.name}</p>
            )}
          </div>
          <div>
            <label
              htmlFor="contact"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaPhone className="mr-2 text-green-500 h-4 w-4" /> Phone Number
            </label>
            <input
              type="text"
              id="contact"
              value={formData.contact}
              onChange={handleChange}
               maxLength={10} 
              className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
            />
            {errors.contact && (
              <p className="text-red-500 text-xs italic">{errors.contact}</p>
            )}
          </div>
          <div>
            <label
              htmlFor="email"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaUser className="mr-2 text-blue-500 h-4 w-4" /> Email
            </label>
            <input
              type="email"
              id="email"
              value={formData.email  || ""}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
            />
            {errors.email && (
              <p className="text-red-500 text-xs italic">{errors.email}</p>
            )}
          </div>
          <div>
            <label
              htmlFor="propertyAddress"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaHome className="mr-2 text-yellow-500 h-4 w-4" /> Property Name
            </label>
           

{isPropertyLoading ? (
  <SuggestionInput
    loading={true} // Show loading state inside the input
    suggestions={[]} // No suggestions while loading
    activeValue={formData.propertyName}
    setActiveValue={(value: string) => {
      setFormData({ ...formData, propertyName: value });
    }}
    setActiveIndex={() => {}} // No action while loading
  />
) : (
  <SuggestionInput
    key={unoccupiedProperties.length}
    suggestions={unoccupiedProperties.map((property: { propertyName: any; }) => property.propertyName)}
    setActiveValue={(value: string) => {
      setFormData({ ...formData, propertyName: value });
    }}
    activeValue={formData.propertyName}
    setActiveIndex={(index: number) => {
      const selectedProperty = unoccupiedProperties[index];
      if (selectedProperty) {
        setFormData({
          ...formData,
          depositAmount: selectedProperty.propertyDepositAmount,
          rent: selectedProperty.propertyRent,
          propertyAddress: selectedProperty.id,
          propertyName: selectedProperty.propertyName,
        });
      }
    }}
    loading={false} // No loading state
  />
)}
            {errors.propertyAddress && (
              <p className="text-red-500 text-xs italic">
                {errors.propertyAddress}
              </p>
              
            )}
          </div>
          <div>
            <label
              htmlFor="occupation"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaBriefcase className="mr-2 text-purple-500 h-4 w-4" />{" "}
              Occupation
            </label>
            <input
              type="text"
              id="occupation"
              value={formData.occupation}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
            />
            {errors.occupation && (
              <p className="text-red-500 text-xs italic">{errors.occupation}</p>
            )}
          </div>
          <div>
            <label
              htmlFor="dueDate"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaCalendarAlt className="mr-2 text-orange- 500 h-4 w-4" /> Due
              Date
            </label>


      
           <div 
           ref={dueDateRef}
           onClick={() => setDueDateDropdownOpen(!dueDateDropdownOpen)}>
              <Dropdown
                options={DueDateOptions}
                onSelect={(e: any) => {
                  setFormData({ ...formData, dueDate: parseInt(e) });
                  setDueDateDropdownOpen(false);
                }}
                activeOption={JSON.stringify(formData.dueDate)}
                className2="py-2"
                className="w-[100%]"
                isOpen={dueDateDropdownOpen}
                setIsOpen={setDueDateDropdownOpen}
                closeOtherDropdown={() => {}}
              />
            </div>
           
            {errors.dueDate && (
              <p className="text-red-500 text-xs italic">{errors.dueDate}</p>
            )}
          </div>
          <div>
            <label
              htmlFor="occupiedDate"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaCalendarAlt className="mr-2 text-orange-500 h-4 w-4" />{" "}
              Occupied Date
            </label>
            <input
              type="date"
              id="occupiedDate"
              value={formData.occupiedDate}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
            {errors.occupiedDate && (
              <p className="text-red-500 text-xs italic">
                {errors.occupiedDate}
              </p>
            )}
          </div>
              <div>
            <label
              htmlFor="vacatedDate"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaCalendarAlt className="mr-2 text-orange-500 h-4 w-4" />{" "}
              Vacated Date
            </label>
            <input
              type="date"
              id="vacatedDate"
              value={formData.vacatedDate}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
            {errors.vacatedDate && (
              <p className="text-red-500 text-xs italic">
                {errors.vacatedDate}
              </p>
            )}
          </div>
          <div>
            <label
              htmlFor="depositAmount"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaMoneyBillWave className="mr-2 text-green-500 h-4 w-4" />{" "}
              Deposit Amount
            </label>
            <input
              type="number"
              disabled
              id="depositAmount"
              value={formData.depositAmount}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
            />
            {errors.depositAmount && (
              <p className="text-red-500 text-xs italic">
                {errors.depositAmount}
              </p>
            )}
          </div>
          <div>
            <label
              htmlFor="rent"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaMoneyBillWave className="mr-2 text-green-500 h-4 w-4" /> Rent
            </label>
            <input
              type="number"
              id="rent"
              disabled
              value={formData.rent}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
            />
            {errors.rent && (
              <p className="text-red-500 text-xs italic">{errors.rent}</p>
            )}
          </div>
       

          <div>
            <label
              htmlFor="openingBalance"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaMoneyBillWave className="mr-2 text-green-500 h-4 w-4" />{" "}
              Opening Balance
            </label>
            <input
              type="number"
              id="openingBalance"
              value={formData.openingBalance}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
            />
            {errors.openingBalance && (
              <p className="text-red-500 text-xs italic">
                {errors.openingBalance}
              </p>
            )}
          </div>

          <div className="flex items-end"> {/* Changed to items-end to align with input */}
    <div className="w-full mt-[22px]"> {/* Adjusted margin to match label height */}
      <div className="flex items-center space-x-2">
        <label htmlFor="active-toggle" className="block text-sm text-gray-700 font-bold flex items-center">
          <FaUserCog className="mr-2 h-5 text-green-500 w-5" /> Status:
        </label>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            id="active-toggle"
            className="sr-only peer"
            checked={activeStatus}
            onChange={handleToggleChange}
            disabled={isLoading}
          />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
          <span className="ms-3 text-sm font-medium text-gray-900">
            {activeStatus ? 'Active' : 'Inactive'}
          </span>
        </label>
      </div>
    </div>
  </div>
          <div className="mt-4">
            <label
              htmlFor="tenatsImageUrl"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaUser className="mr-2 text-blue-500 h-4 w-4" /> Tenant Image
            </label>
            <input
              type="file"
              id="tenatsImageUrl"
              onChange={handleImageChange}
              className="hidden"
            />
            <label
              htmlFor="tenatsImageUrl"
              className="cursor-pointer text-blue-500"
            >
              Drag and drop file here or click to upload
            </label>
            {formData.tenantImage && (
              <p className="text-sm text-gray-700">
                Image uploaded:{" "}
                <span
                  className="cursor-pointer"
                  onClick={() =>
                    handleImageClick(url2 ? url2 : formData.tenantImage)
                  }
                  rel="noopener noreferrer"
                >
                  View
                </span>
              </p>
            )}
          </div>
          <div className="mt-4">
            <label
              htmlFor="documentUrl"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaPlusCircle className="mr-2 text-red-500 h-4 w-4" /> Upload
              Document
            </label>
            <input
              type="file"
              id="documentUrl"
              onChange={handleFileChange}
              className="hidden"
            />
            <label
              htmlFor="documentUrl"
              className="cursor-pointer text-blue-500"
            >
              Drag and drop file here or click to upload
            </label>
          {formData.document && (
          <p className="text-sm text-gray-700">
            Document uploaded:{" "}
            <span
              onClick={() => handleDocumentClick(url1 ? url1 : formData.document)}
              className="cursor-pointer text-blue-500 hover:underline"
            >
              View
            </span>
          </p>
        )}
      </div>
        </div>

        <div className="mt-4">
          <label
            htmlFor="comments"
            className="text-sm text-gray-700 font-bold flex items-center"
          >
            <FaCommentDots className="text-indigo-500 h-5 w-5 mr-2" /> Comments
          </label>
          <textarea
            id="comments"
            value={formData.comments}
            onChange={handleChange}
            className=" shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none p-2 focus:shadow-outline"
          />
        </div>
 
        <div className="flex flex-col sm:flex-row justify-end mt-4 space-y-2 sm:space-y-0 sm:space-x-4">
          <button
            disabled={isLoading}
            type="submit"
            className="bg-primary hover:bg-secondary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
             {isLoading?<p className="flex justify-center items-center"><FaSpinner className="animate-spin mr-2"/> Updating...</p>:"Save"}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Cancel
          </button>
        </div>

        
      </form>
       <DocumentViewer
        isOpen={documentViewer.isOpen}
        url={documentViewer.url}
        type={documentViewer.type}
        tenantId={initialData?.id || 0} // Use the tenant ID if available
        onClose={() => setDocumentViewer({ isOpen: false, url: '', type: '' })}
      />
        {imageToShow && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setImageToShow(null)}
        >
          <div className="relative max-w-4xl max-h-[90vh]">
            <button 
              onClick={() => setImageToShow(null)}
              className="absolute top-2 right-2 text-white bg-black bg-opacity-50 rounded-full p-1"
            >
              <MdClose size={24} />
            </button>
            <img 
              src={imageToShow} 
              alt="Tenant" 
              className="max-w-full max-h-[90vh] object-contain"
            />
          </div>
        </div>
      )}
      {/* Popup for uploaded images */}
      {showPopup && (
        <Popup closeButton={true} onClose={closePopup}>
          <img
            src={imageUrl || ""}
            alt="Uploaded"
            className="max-w-full max-h-full"
          />
        </Popup>
      )}
    </div>
  );
};
export default TenantForm;

